var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5.917C16.41.917.917 16.41.917 35.5c0 19.09 15.493 34.584 34.583 34.584 19.09 0 34.583-15.494 34.583-34.584C70.083 16.41 54.59.917 35.5.917zm0 62.25C20.249 63.167 7.833 50.75 7.833 35.5 7.833 20.249 20.25 7.833 35.5 7.833c15.251 0 27.667 12.416 27.667 27.667 0 15.251-12.416 27.667-27.667 27.667zm-6.917-20.162l22.79-22.79 4.877 4.91-27.667 27.667L14.75 38.959l4.876-4.877 8.957 8.923z",
    fill: "#27AE60"
  })));
}

var MemoSvgSuccess = /*#__PURE__*/React.memo(SvgSuccess);
export default MemoSvgSuccess;